
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 44 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.429 35.568l-9.62-2.733L41.3 17.874c.279 1.332.428 2.71.428 4.125 0 5.236-2.02 9.995-5.3 13.568zm-19.67 5.771L14.24 31.31l20.568 5.846c-3.485 3.03-8.009 4.875-12.96 4.875-1.762 0-3.462-.256-5.09-.69zM2.917 28.091l6.726-7 4.902 19.52A20.047 20.047 0 012.917 28.09zm4.61-19.948l9.273 2.653L2.345 25.845A20.183 20.183 0 011.971 22c0-5.376 2.123-10.254 5.556-13.856zm18.572-5.7l2.642 9.718-19.552-5.59a19.694 19.694 0 0112.66-4.6c1.46 0 2.879.169 4.25.472zM14.013 29.197l-.161.567-2.6-10.349 7.69-8.006 10.404 2.975 2.759 10.151-7.446 7.688-10.646-3.026zm26.681-13.529l-6.994 7.22L28.313 3.08c5.824 2.026 10.425 6.696 12.382 12.59zM21.848 0C9.801 0 0 9.87 0 22s9.801 22 21.848 22c12.05 0 21.85-9.87 21.85-22s-9.8-22-21.85-22z","fill":"#020203"}})])
          )
        }
      }
    